import {AfterViewInit, Component, HostListener, Inject, PLATFORM_ID} from '@angular/core';

import {SubService} from './services/sub.service';
import {ModalController} from '@ionic/angular';
import {AuthComponent} from './helpers/auth/auth.component';
import {JoinTraderComponent} from './helpers/join-trader/join-trader.component';
import {ArbameService} from './services/arbame.service';
import {isPlatformBrowser} from '@angular/common';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',

})
export class AppComponent implements AfterViewInit {
  ngAfterViewInit(): void {
    this.setScreenWidth();
    this.sendLandingEventOnceADay();
    this.route.queryParams.subscribe((data) => {

      // @ts-ignore
      if (data?.login) {
        this.sub.openAuth.next(true);
      }
    });
  }
  sendLandingEventOnceADay(): void {
    const lastEventDate = localStorage.getItem('lastLandEventDate');
    const today = new Date().toISOString().split('T')[0]; // Get current date in YYYY-MM-DD format

    if (lastEventDate !== today) {
      this.sendEvent('land');
      localStorage.setItem('lastLandEventDate', today); // Update date in localStorage
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.setScreenWidth();
  }

  constructor(private route: ActivatedRoute, @Inject(PLATFORM_ID) public platformId: any, @Inject(SubService) private sub: SubService, private modalCtrl: ModalController, private aService: ArbameService) {
    this.sub.openAuth.subscribe((data) => {
      if (data) {
        this.OpenAuth();
      }
    });
    this.sub.joinTrade.subscribe((data) => {
      if (data) {
        this.join();
      }
    });
    this.sub.loadAppInit.subscribe((data) => {
      if (data) {
        this.loadAppInit();
      }
    });
    this.loadAppInit();
  }

  sendEvent(type) {
    const fd = new FormData();
    fd.append('type', type);
    this.aService.sendEvent(fd).subscribe((data) => {

    });
  }

  appInitData;
  isMobile;

  setScreenWidth() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.sub.currentScreenWidth.next(window.innerWidth);
    if (window.innerWidth < 1100) {
      this.sub.isMobile.next(true);
      this.isMobile = true;
    } else {
      this.sub.isMobile.next(false);
      this.isMobile = false;
    }
  }

  loadAppInit() {

    this.aService.appInit().subscribe((data) => {
      this.appInitData = data.data;
      if (isPlatformBrowser(this.platformId)) {
        if (data?.data?.cart_group_id) {
          localStorage.setItem('cgi', data?.data?.cart_group_id);
        } else {
          localStorage.removeItem('cgi');
        }
      }

      this.sub.reloadBasket.next(true);
      this.sub.appInitData.next(data);
      this.sub.countCart.next(this.appInitData.cart_items_count);
    }, error => {
      if (isPlatformBrowser(this.platformId)) {
        if (localStorage.getItem('cgi')) {
          this.aService.getCart(localStorage.getItem('cgi'), null).subscribe((data) => {
            this.sub.countCart.next(data.data.cart_items.length);
          }, error => {

          });
        }
      }
    });
  }

  async OpenAuth() {
    const modal = await this.modalCtrl.create({
      component: AuthComponent,
      cssClass: 'auth-modal',
      backdropDismiss: true,

    });
    modal.present();
    await modal.onWillDismiss().then((data) => {
      if (data.data?.type === 'cancel') {
      }
    });
  }

  async join() {
    const modal = await this.modalCtrl.create({
      component: JoinTraderComponent,
      cssClass: 'join-modal auth-modal',
      backdropDismiss: true,

    });
    modal.present();
    await modal.onWillDismiss().then((data) => {
      if (data.data?.type === 'cancel') {
      }
    });
  }
}

